import { createAction, props } from '@ngrx/store';
import { TreeNode } from 'primeng/api';

export const toggleNode = createAction('InternalDivisionToggleNode', props<{ key: string; expanded: boolean }>());

export const selectNode = createAction('InternalDivisionSelectNode', props<{ key: string }>());

export const loadDivisionsSuccess = createAction('InternalDivisionLoadSuccess', props<{ divisions: TreeNode[] }>());

export const refreshTree = createAction('InternalDivisionRefresh');

export const setSelectedStock = createAction('InternalDivisionSetSelectedStock', props<{ stockId: number | null }>());
